import { Component, Input } from '@angular/core';
import {NavController, NavParams, PopoverController, Tabs} from 'ionic-angular';
import { ServiceSummaryPage } from '../service-summary/service-summary';
import { HttpClient } from '@angular/common/http';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';
import { TimezoneProvider } from '../../providers/timezone/timezone';
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";
import {ServiceQuantityModal} from "../service-quantity-modal/service-quantity-modal";
import {AdditionalServiceSummaryPage} from "../additional-service-summary/additional-service-summary";

/**
 * Generated class for the ServicesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-services',
  templateUrl: 'services.html',
})
export class ServicesPage {
  shop: any;
  barber: any;
  booking: any;
  bookingType: number;
  advancedBooking: any;
  errors: {};
  loading: boolean;
  selectedCategoryIndex: number = 0;
  categories: any = [];
  services: any;
  availableTime: number;
  selected: any = {};
  byStaff: boolean;
  fromLobby: boolean;
  fromStaffPanel: boolean;
  availableTimeHeading: string;
  currencySymbol: string;
  banner: boolean = false;
  guestUser: any = null;
  selectedServicesCount: number = 0;
  private selectedPromorSerivces: number = 0;
  selectedServicesDuration: number = 0;
  isAdditionalService: boolean = false;
  public promo_products: any = {promo_product_limit: 0, promo_product_count: 0};
  public poromoProductCount: number;
  public isContinue: boolean = true;
  private tuid: string;
  
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private http: HttpClient,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private tz: TimezoneProvider,
    private tabsService: TabsServiceProvider,
    private popoverCtrl: PopoverController
  ) {
    this.tuid = localStorage.getItem('tuid');
    this.tabsService.hide();
    this.booking = navParams.get('booking');
    this.services = (this.booking && this.booking.full_services) ? this.booking.full_services : [];
    this.resetServicesSelection();
    this.shop = navParams.get('shop');
    this.barber = navParams.get('barber');
    this.bookingType = navParams.get('bookingType')
      ? navParams.get('bookingType')
      : 1; // 1 = Standard
    this.advancedBooking = navParams.get('advancedBooking');
    this.byStaff = navParams.get('byStaff') ? true : false;
    this.fromLobby = navParams.get('fromLobby') ? true : false;
    this.fromStaffPanel = navParams.get('fromStaffPanel') ? true : false;
    this.guestUser = navParams.get('guestUser');
    this.isAdditionalService = navParams.get('isAdditionalService');

    this.getPromoLimits();
  }

  ionViewWillEnter() {
    this.availableTimeHeading =
      this.booking || this.advancedBooking || this.byStaff
        ? 'Service Time'
        : 'Available Time';

    // Load services for a barber if services has not been passed as parameters
    this.loading = true;
    this.getShop().then((shop: any) => {
      this.shop = shop;

      this.tz.timezone(this.shop).then((currencySymbol: string) => {
        this.currencySymbol = currencySymbol;
      });

      if (this.advancedBooking || shop.has_active_barbers) {
        this.getCategories().then(categories=>{
          // this.resetServicesSelection();
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });

  }


  getPromoLimits() {
    return new Promise((resolve, reject) => {
    let teamId = this.getTeamId();
    let endpoint = `/users/${this.tuid}/teams/${teamId}/promo_products`;
    
    this.http.get(endpoint).subscribe((promo_products: any) => {
        this.promo_products = promo_products;
        resolve(promo_products);
      }, (error) => {
        this.errors = this.apiErrorHandler.handleError(error);
        reject(error);
      },
      () => {},
      );
    });
  }

  selectCategory(categoryIndex){
    this.selectedCategoryIndex = categoryIndex;
  }

  getCategories() {
    return new Promise((resolve, reject) => {
      let teamId = this.getTeamId();
      let endpoint = `/teams/${teamId}/members/${this.barber.id}/active-categories-with-services?tuid=${this.tuid}`;

      if (this.booking && this.booking.available_duration) endpoint += '&available_duration=' + this.booking.available_duration;
      if (this.byStaff) endpoint += '&show_hidden_services=true';

      this.http.get(endpoint).subscribe(
        (categories: any) => {
          categories.forEach((category: any) => {
            if (category.services && category.services.length) {
              category.services = this.deleteIconFromName(category.services);
            }
          });
          
          this.categories = categories;
          resolve(categories);
        },
        (error) => {
          this.errors = this.apiErrorHandler.handleError(error);
          reject(error);
        },
        () => {},
      );
    });
  }
  private deleteIconFromName(services: any[]): any[] {
    services.sort((a, b) => Number(a.order) - Number(b.order));
    return services.map((service: any) => {
      const latters: string[] = service.name.split('').filter((latter: string) => latter !== "\ud83c" && latter !== "\udd93");
      latters[latters.length-1] === ' ' ? latters.pop() : null;
      service.name = latters.join('');
      return service;
    });
  }

  resetServicesSelection() {
    this.selected.availableTime = 0;
    this.services.forEach(function(service) {
      delete service.selected;
      delete service.disabled;
    });
    this.setSelectedServicesCount();
  }

  chooseServiceQuantity(service){

    if (service.disabled && !this.byStaff) return;

    let services = this.services;
    let serviceQuantityModal = this.popoverCtrl.create(ServiceQuantityModal, {
      service: service,
      selectedServicesCount: this.selectedServicesCount,
      selectedServicesDuration: this.selectedServicesDuration,
      availableServiceDuration: (this.booking && this.booking.available_duration ? this.booking.available_duration : null),
      currencySymbol: this.currencySymbol,
      byStaff: this.byStaff,
      shopType: 'barber'
    }, {
      enableBackdropDismiss: false
    });

    serviceQuantityModal.present();

    serviceQuantityModal.onWillDismiss(_=>{
      this.setSelectedServices();
      this.setSelectedServicesCount();
    });

  }

  setSelectedServices(){
    this.selected = {};
    this.selected.services = [];
    this.selected.totalCost = 0;
    this.selected.availableTime = 0;
    this.categories.forEach(category=>{
      category.services.forEach(service=>{
        if (!service.selected) return;
        this.selected.services.push(service);
      })
    });
  }

  setSelectedServicesCount(){
    this.selectedServicesCount = 0;
    this.selectedPromorSerivces = 0;
    this.selectedServicesDuration = 0;

    this.categories.forEach(category=>{
      category.selectedServicesCount = 0;
      category.services.forEach(service=>{
        
        if (service.selected && service.quantity > 0) {
          if(service.price <= 0 && service.promo_product == 1) {
            this.selectedPromorSerivces += service.quantity;
          }
          category.selectedServicesCount += service.quantity;
          this.selectedServicesCount += service.quantity;
          this.selectedServicesDuration += (service.quantity * service.duration);
        }
      })
    });

    this.poromoProductCount = this.promo_products.promo_product_limit - this.promo_products.promo_product_count - this.selectedPromorSerivces
    this.isContinueFunction();
  }

  isContinueFunction() {
    if(this.loading || this.selectedServicesCount < 1) {
      return this.isContinue = true;
    } else {
      if(this.poromoProductCount < 0) {
        return this.isContinue =true;
      }
      return this.isContinue = false;
    }
  }

  openServiceSummaryPage(event: any, services: any) {
    this.navCtrl.push(ServiceSummaryPage, {
      services: services,
      shop: this.shop,
      barber: this.barber,
      bookingType: this.bookingType,
      advancedBooking: this.advancedBooking,
      byStaff: this.byStaff,
      fromLobby: this.fromLobby,
      fromStaffPanel: this.fromStaffPanel,
      booking: this.booking,
      guestUser: this.guestUser,
    });
  }

  openAdditionalServiceSummaryPage(event: any, services: any) {
    this.navCtrl.push(AdditionalServiceSummaryPage, {
      services: services,
      shop: this.shop,
      booking: this.booking,
      fromLobby: this.fromLobby
    });
  }

  getShop() {
    return new Promise((resolve, reject) => {
      let teamId = this.getTeamId();
      this.http.get(`/teams/${teamId}`).subscribe(
        (shop: any) => {
          return resolve(shop);
        },
        (error) => {
          this.errors = this.apiErrorHandler.handleError(error);
          return reject();
        },
        () => {},
      );
    });
  }

  getTeamId(){
    return this.shop.id ? this.shop.id : localStorage.getItem('currentTeamId');
  }
}



// WEBPACK FOOTER //
// ./src/pages/services/services.ts